import React from 'react'
import { Route, Switch } from 'react-router-dom'
import DevLogin from './DevLogin'

const Entry = () => {
  return <Switch>
    <Route path={'/v3/dev-login'} component={DevLogin}></Route>
  </Switch>
}

export default Entry